import { isPublicUrlAccess, getApiUrl, defaultHeaders, MARKERS } from 'mt-shared';

const API_URL: string = getApiUrl();

if (!isPublicUrlAccess()) {
  const settings = {
    method: 'GET',
    url: `${API_URL}/api/w2/sessions/validate`,
    headers: defaultHeaders,
  };

  if (window.location.href.includes('apply-cards')) {
    settings.url = `${settings.url}?cards_user=true`;
  }

  window['validationData'] = null;
  window['validationError'] = null;
  window.performance.mark(MARKERS.VALIDATE_CALL_START);
  fetch(settings.url, {
    method: 'GET',
    headers: settings.headers || {},
  })
  .then(response => {
    window.performance.mark(MARKERS.VALIDATE_CALL_END);

    if (!response.ok) {
      return response.json().then(data => {
        const errorWithStatus = {
          ...data,
          ...(response?.status && { status: response.status }),
        };
        throw errorWithStatus;
      });
    }
    return response.json();
  })
  .then(data => {
    window['validationData'] = data;
  })
  .catch(error => {
    window['validationError'] = error;
  })
  .finally(() => window.dispatchEvent(new Event('validation-done')));
}